import type { ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  tone?: "primary" | "accent" | "secondary" | "outline";
  className?: string;
}

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700 border-primary-200",
  accent: "bg-accent-100 text-accent-800 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
  outline: "bg-background-50 text-foreground-600 border-background-300",
};

export default function Badge({ children, tone = "secondary", className = "" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${toneMap[tone]} ${className}`}
    >
      {children}
    </span>
  );
}